import { AxiosError } from 'axios';
import { t } from 'common/i18n';
import ProxyPolyfillBuilder from 'proxy-polyfill/src/proxy';
import { Api } from './generated-api';

const ProxyPolyfill = ProxyPolyfillBuilder();

const apiInstance = new Api();
const wrapClientRequest =
  // eslint-disable-next-line @typescript-eslint/ban-types
  <T extends Function>(method: T) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (async (...args: any[]) => {
      try {
        return await method(...args);
      } catch (e) {
        const error = e as AxiosError;
        const errorData = error.response?.data as { error: string } | undefined;

        if (error.response?.status === 429) {
          throw new Error(t('validation', 'tooManyRequests'));
        }

        if (errorData?.error) {
          throw new Error(errorData?.error);
        }

        throw error;
      }
    }) as unknown as T;
  };

const apiClientHandler: ProxyHandler<(typeof apiInstance)[keyof typeof apiInstance]> = {
  get: (client, params: keyof typeof client) => {
    const method = client[params];
    return wrapClientRequest(method);
  },
};

export const createProxy = <T extends (typeof apiInstance)[keyof typeof apiInstance]>(client: T) =>
  new ProxyPolyfill(client, apiClientHandler) as typeof client;
